import React from "react";
import styles from "./SwanGetFitted.module.scss";

const SwanGetFitted = ({ data, loading,handleRedirect }) => {

	return (
	<div id="swan-btn-parent-div" style={{cursor:"pointer"}}>
	{loading ? <div className={styles.swanCtaLoading} >&nbsp;</div> : (
		<>
			<div id="swan-btn" className={styles.swanCtaHolder}>
			<div id="result"  className={styles.swanCtaHolder__inner}  onClick={handleRedirect}>{data}</div>
			</div>
		</>
		
	)}
	</div>)
};

export default SwanGetFitted;
